


import { Routes, RouterModule } from '@angular/router';
import { ExecutionPointerComponent } from './executionpointer.component';

const routes: Routes = [
    {
        path: '',
        component: ExecutionPointerComponent
    },
];

export const ExecutionPointerRoutes = RouterModule.forChild(routes);
